import { CustomPDFReportType } from 'CustomPDFReportsApp/ts/enums/custom-pdf-report-type.enum';
import { Language } from 'NewAngular/enums/language.enum';
export const CUSTOM_PDF_REPORTS_LIST_APP_STATE_SLICE_KEY = 'customPDFReportsList';
const CUSTOM_PDF_REPORTS_LIST_STATE_KEYS = [
    'language',
    'owner',
    'page',
    'reportType',
    'sortColumn',
    'sortDirection',
    'name',
    'viewRootFolder',
    'includeEmptyFolders',
];
// The system default state excludes sortColumn and sortDirection
export const CUSTOM_PDF_REPORTS_LIST_SYSTEM_DEFAULT_STATE = {
    language: {
        [Language.ENGLISH]: true,
        [Language.FRENCH]: true,
    },
    reportType: {
        [CustomPDFReportType.AGGREGATE_SECURITY_OVERVIEW]: true,
        [CustomPDFReportType.AGGREGATE_SECURITY_COMPARISON]: true,
        [CustomPDFReportType.MULTI_SECURITY_COMPARISON]: true,
    },
    owner: {
        me: true,
        shared_with_me: true,
        public: true,
    },
    page: 1,
    name: '',
    viewRootFolder: null,
    includeEmptyFolders: true,
};
export { CUSTOM_PDF_REPORTS_LIST_STATE_KEYS };
